
export class AddressDto {
    addressType: string;
    addressLine: string;
    postCode: string;
    town: string;
    county: string;
    country: string;
}


export class EmailDto {
    emailType: string;
    email: string;
}


export class PhoneDto {
    phoneType: string;
    number: string;
}



// WEBPACK FOOTER //
// ./ClientApp/dto/address.ts